import styled from 'styled-components';
import { flexRowCSS, flexColCSS } from '../styled';

export const StyledSummary = styled.div`
  min-height: 60px;
  margin: 10px;
  height: 65px;
  width: 90%;
  position: relative;
  ${flexRowCSS}
  align-items: center;
`;

export const MetricDivider = styled.div`
  width: 1px;
  background: #979797;
  opacity: 0.5;
  padding-bottom: 1px;
  height: 80%;
  margin-right: 10px;
`;

export const MetricTileWrapper = styled.div<{ selected?: 'boolean' }>`
  ${flexColCSS}
  height: 55px;
  width: 110px;
  align-items: flex-start;
  padding: 2.5px 0;
  background-color: ${({ selected }) => (selected ? '#E9F3FD' : '#fff')};

  &:hover {
    background: #e9f3fd;
  }

  margin: 2.5px 0;
`;

export const MetricNameWrapper = styled.div`
  flex-grow: 1;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  text-align: left;
`;

export const MetricValueWrapper = styled.div`
  flex-grow: 1;
  ${flexRowCSS};
  align-items: center;
  text-align: left;
`;

export const MetricValue = styled.div`
  font-size: 16px;
  line-height: 33px;
  font-weight: 600;
`;

export const MetricUnit = styled.div`
  font-weight: 300;
  padding-left: 2px;
`;

export const SpiKpiLabel = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: #8c8c8c;
  margin-left: 4px;
`;

export const ErrorMessage = styled.div`
  color: #c32828;
  padding: 0 5px;
  text-align: center;
  width: 100%;
`;
